//cs-ecommerce/src/store/account/getters.js
export function user (state) {
    return state.userData
}